import React, { useEffect } from 'react';

import { Home } from '@mui/icons-material';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getMyQuotes } from './operations';
import { SubHeader } from '../../../components';
import QuotesTable from '../../../components/QuoteTable';

import './styles.scoped.css';

const MyQuotes = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { subHeaderText } = useSelector(state => state.quoteEngine);
  const { myQuotes, loading } = useSelector(state => state.myQuotes);

  useEffect(() => {
    getMyQuotes(dispatch);
  }, []);

  return (
    <>
      <SubHeader
        text={subHeaderText}
        buttons={[{ icon: <Home sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/quote-engine') }]}
        popoverTitle="Need help with your quote?"
      />
      <Container className="wrap">
        <h1 className="title">My Quotes</h1>
        <QuotesTable data={myQuotes} loading={loading} />
        <Container />
      </Container>
    </>
  );
};

export default MyQuotes;
